<script>
  import GrupoPermissaoService from '../../../../domain/grupos-permissao/services/grupo-permissao'
  import PermissaoService from '../../../../domain/grupos-permissao/services/permissao'
  import { isArray } from 'lodash'

  export default {
    components: {},
    nome: 'novo-grupo',
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          nome: null,
          permissions: []
        },
        permissions: [
          {id: 1, nome: 'Permissão 1'},
          {id: 2, nome: 'Permissão 2'},
          {id: 3, nome: 'Permissão 3'},
          {id: 4, nome: 'Permissão 4'},
          {id: 5, nome: 'Permissão 5'},
          {id: 6, nome: 'Permissão 6'}
        ],
        filtroDisponiveis: '',
        filtroSelecionados: ''
      }
    },
    computed: {
      filteredAvailablePermissions () {
        const filtro = this.filtroDisponiveis
        const array = this.permissions
        return this.filterArray(array, filtro)
      },
      filteredSelectedPermissions () {
        const filtro = this.filtroSelecionados
        const array = this.data.permissions
        return this.filterArray(array, filtro)
      }
    },
    created () {
      this.loadPermissions()
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id) {
          this.$loaderOverlay.open().message('Carregando')
          GrupoPermissaoService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        this.$loaderOverlay.hide()
        const request = this.montarRequest()
        GrupoPermissaoService.cadastrar(request, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      loadPermissions () {
        PermissaoService.list(100000, 1, '')
          .then(result => {
            this.permissions = result.data.result
          })
          .catch(error => {
            console.log(error.response.data)
          })
      },
      addAllPermissions () {
        if (confirm('Adicionar todas as permissões?')) {
          this.data.permissions = this.permissions.map(v => v)
        }
      },
      removeAllPermissions () {
        if (confirm('Remover todas as permissões?')) {
          this.data.permissions = []
        }
      },
      filterArray (array, filter) {
        if (!filter.length) {
          return array
        }
        const regex = new RegExp(filter.toLowerCase())
        return array.filter(item => item.id === filter || item.nome.toLowerCase().match(regex))
      },
      removePermission (index) {
        if (confirm('Remover permissão?')) {
          this.data.permissions.splice(index, 1)
        }
      },
      montarRequest () {
        const tmp = JSON.parse(JSON.stringify(this.data))
        tmp.permissions = tmp.permissions.map(v => v.id)
        return tmp
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Grupo de Permissão</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'config.grupos.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Selecionar permissões</label>
                <div class="col-sm-4">
                  <label class="control-label">Permissões disponíveis</label>
                  <input type="text" placeholder="Filtrar permissões" class="form-control" v-model="filtroDisponiveis">
                  <select class="form-control select-multiple" multiple v-model="data.permissions">
                    <option :value="p" v-for="p in filteredAvailablePermissions" :key="p.id">{{p.nome}}</option>
                  </select>
                  <div class="row wrapper">
                    <u-button class="btn btn-sm m-b-xs m-r-xs btn-default" @click="addAllPermissions">
                      <i class="fa fa-plus"></i> Adicionar todos
                    </u-button>
                  </div>
                </div>
                <div class="col-sm-4">
                  <label class="control-label">Permissões selecionadas</label>
                  <input type="text" placeholder="Filtrar permissões" class="form-control" v-model="filtroSelecionados" />
                  <!--select class="form-control select-multiple" multiple>
                    <option :value="p.id" v-for="p in filteredSelectedPermissions" :key="p.id">
                      {{p.nome}}
                    </option>
                  </select-->
                  <div class="form-control select-multiple">
                    <ul class="list-group" style="list-style-type: none">
                      <li :value="p.id" v-for="(p, index) in filteredSelectedPermissions" :key="p.id">
                          <i class="fa fa-times" style="cursor:pointer;" title="Clique para remover este item" @click="removePermission(index)"></i> {{p.nome}}
                      </li>
                    </ul>
                  </div>
                  <div class="row wrapper">
                    <u-button class="btn btn-sm m-b-xs m-r-xs btn-default" @click="removeAllPermissions">
                      <i class="fa fa-times"></i> Remover todos
                    </u-button>
                  </div>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.grupos.list'})">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .select-multiple {
    height: 260px;
  }
</style>



// WEBPACK FOOTER //
// NovoGrupo.vue?555ba040